//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    component: {
      type: String,
      default: 'nuxt-link',
      validator (val) {
        return ['a', 'nuxt-link', 'NuxtLink'].indexOf(val) !== -1
      }
    },
    href: {
      type: [String, Object],
      default: null
    },
    backLink: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        click: (e) => {
          if (this.$listeners.click) {
            e.preventDefault()
            this.$emit('click')
          }
        }
      }
    },
    comp () {
      return this.component === 'nuxt-link' && !this.linkAttrs.to ? 'a' : this.component
    },
    linkAttrs () {
      return {
        ...this.$attrs,
        [this.component === 'nuxt-link' ? 'to' : 'href']: this.href
      }
    }
  }
}
